<mbs-alert
  [type]="alertType.info"
  [icon]="true">
  {{
    authFacade.currentUserValue?.IsProvider
      ? ('shared:tfa.canConfigureTfaAtAnyTime' | i18next)
      : ('shared:tfa.canConfigureTfaAtAnyTimeInMyProfile' | i18next)
  }}
</mbs-alert>
